import React from 'react';
import Form from 'containers/PasswordRecoveryPages/PinMethodForgotPassword/Form';
import { connect } from 'react-redux';
import { setPasswordRecoveryStep } from 'store/credentials/actions';
import { CHOOSE_METHODS_RECOVERY_PASS } from 'containers/PasswordRecoveryPages/constants';
import Header from 'containers/PasswordRecoveryPages/Header';
import { injectIntl, IntlShape } from 'react-intl';
import messages from 'containers/PasswordRecoveryPages/PinMethodForgotPassword/messages';
import { translate } from 'helpers/intl';
import {
  getErrorMessageSelector,
  getHashedEmailSelector,
} from 'store/credentials/selectors';
import { createStructuredSelector } from 'reselect';
const PinMethodForgotPassword = ({
  setPasswordRecoveryStep,
  onSubmitStep,
  isLoading,
  hashedEmail,
  errorMessage,
  ...otherProps
}: {
  setPasswordRecoveryStep: Function;
  onSubmitStep: Function;
  isLoading: Boolean;
  intl: IntlShape;
  hashedEmail: string;
  errorMessage: string;
}) => {
  return (
    <React.Fragment>
      <Header
        title={translate(messages.formTitle, otherProps)}
        subTitle={translate(messages.formSubTitle, otherProps)}
      />
      <Form
        onSubmitStep={onSubmitStep}
        proceedDifferently={() =>
          setPasswordRecoveryStep(CHOOSE_METHODS_RECOVERY_PASS)
        }
        isLoading={isLoading}
        hashedEmail={hashedEmail}
        errorMessage={errorMessage}
      />
    </React.Fragment>
  );
};

const mapPropsToProps = createStructuredSelector<
  any,
  {
    hashedEmail: string;
    errorMessage: string;
  }
>({
  errorMessage: getErrorMessageSelector,
  hashedEmail: getHashedEmailSelector,
});
const mapDispatchToProps = {
  setPasswordRecoveryStep,
};
export default connect(
  mapPropsToProps,
  mapDispatchToProps,
)(injectIntl(PinMethodForgotPassword));
export { PinMethodForgotPassword };
